/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type OperationalVehiclesForStateChangeQueryVariables = Types.Exact<{
  regions?: Types.InputMaybe<
    Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
  >
  fleets?: Types.InputMaybe<
    Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
  >
}>

export type OperationalVehiclesForStateChangeQuery = {
  __typename?: 'Query'
  fleetVehicles: {
    __typename?: 'VehiclesResponse'
    vehicles: Array<{
      __typename?: 'Vehicle'
      id: string
      label: number | null
      fleet: { __typename?: 'Fleet'; name: string } | null
    }>
  }
}

export const OperationalVehiclesForStateChangeDocument = gql`
    query OperationalVehiclesForStateChange($regions: [ID!], $fleets: [ID!]) {
  fleetVehicles(
    input: {regions: $regions, states: [ACTIVE], fleets: $fleets, operationalStates: [OPERATIONAL]}
  ) {
    vehicles {
      id
      label
      fleet {
        name
      }
    }
  }
}
    `

/**
 * __useOperationalVehiclesForStateChangeQuery__
 *
 * To run a query within a React component, call `useOperationalVehiclesForStateChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperationalVehiclesForStateChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperationalVehiclesForStateChangeQuery({
 *   variables: {
 *      regions: // value for 'regions'
 *      fleets: // value for 'fleets'
 *   },
 * });
 */
export function useOperationalVehiclesForStateChangeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OperationalVehiclesForStateChangeQuery,
    OperationalVehiclesForStateChangeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OperationalVehiclesForStateChangeQuery,
    OperationalVehiclesForStateChangeQueryVariables
  >(OperationalVehiclesForStateChangeDocument, options)
}
export function useOperationalVehiclesForStateChangeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OperationalVehiclesForStateChangeQuery,
    OperationalVehiclesForStateChangeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OperationalVehiclesForStateChangeQuery,
    OperationalVehiclesForStateChangeQueryVariables
  >(OperationalVehiclesForStateChangeDocument, options)
}
// @ts-ignore
export function useOperationalVehiclesForStateChangeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OperationalVehiclesForStateChangeQuery,
    OperationalVehiclesForStateChangeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OperationalVehiclesForStateChangeQuery,
  OperationalVehiclesForStateChangeQueryVariables
>
export function useOperationalVehiclesForStateChangeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OperationalVehiclesForStateChangeQuery,
        OperationalVehiclesForStateChangeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OperationalVehiclesForStateChangeQuery | undefined,
  OperationalVehiclesForStateChangeQueryVariables
>
export function useOperationalVehiclesForStateChangeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OperationalVehiclesForStateChangeQuery,
        OperationalVehiclesForStateChangeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OperationalVehiclesForStateChangeQuery,
    OperationalVehiclesForStateChangeQueryVariables
  >(OperationalVehiclesForStateChangeDocument, options)
}
export type OperationalVehiclesForStateChangeQueryHookResult = ReturnType<
  typeof useOperationalVehiclesForStateChangeQuery
>
export type OperationalVehiclesForStateChangeLazyQueryHookResult = ReturnType<
  typeof useOperationalVehiclesForStateChangeLazyQuery
>
export type OperationalVehiclesForStateChangeSuspenseQueryHookResult =
  ReturnType<typeof useOperationalVehiclesForStateChangeSuspenseQuery>
export type OperationalVehiclesForStateChangeQueryResult = Apollo.QueryResult<
  OperationalVehiclesForStateChangeQuery,
  OperationalVehiclesForStateChangeQueryVariables
>
